// @flow
import React from 'react';
import './style.less';
import {Nail} from 'modules/common/components/Nail';

type TProps = {
    children?: any,
    className?: string,
    dark?: boolean,
};

function NailBlock({children, className, dark}: TProps) {
    return (
        <div className={`nail-block ${className ? className : ''}`}>
            <Nail dark={dark} left top />
            <Nail bottom dark={dark} left />
            <Nail bottom dark={dark} right />
            <Nail dark={dark} right top />
            {children}
        </div>
    );
}

export {NailBlock};
